import { useState } from "react";
import { useMessagingSettings } from "./useMessagingSettings";
import { Button } from "V2.0/common/button";
import InputComponent from "V2.0/components/InputComponent";

export default function ChatWelcomeMessages(props) {
  const { messagingSettings, syncAssistant, workspaceId, assistantId, locked } =
    props;

  const { loading, setLoading, updateMessagingSettings } = useMessagingSettings(
    {
      syncAssistant,
      workspaceId,
      assistantId,
    }
  );

  const [settings, setSettings] = useState({
    chatWelcomeMessage: messagingSettings?.chatWelcomeMessage || "",
  });
  const [errors, setErrors] = useState({
    chatWelcomeMessage: null,
  });

  function handleUpdateError(updatedError) {
    setErrors((prevErrors) => {
      return {
        ...prevErrors,
        ...updatedError,
      };
    });
  }

  function handleUpdateSettings(updatedSetting) {
    setSettings((prevSettings) => {
      return { ...prevSettings, ...updatedSetting };
    });
  }

  function handleUpdateChatWelcomeMessage(chatWelcomeMessage) {
    if (
      chatWelcomeMessage.length > 350 &&
      !Boolean(errors.chatWelcomeMessage)
    ) {
      handleUpdateError({
        chatWelcomeMessage: "Maximum Character is limited to 350 Characters",
      });
    }

    if (chatWelcomeMessage.length < 350 && Boolean(errors.chatWelcomeMessage)) {
      console.log("Hi");
      handleUpdateError({
        chatWelcomeMessage: null,
      });
    }

    handleUpdateSettings({
      chatWelcomeMessage,
    });
  }

  const handleSave = () => {
    updateMessagingSettings(settings);
  };

  const isSaveDisabled = Object.values(errors).some((value) => Boolean(value));

  return (
    <div className="flex flex-col w-3/5 min-w-[600px] gap-y-2 border rounded-lg m-4">
      <div className="px-6 py-4 bg-gray-50 rounded-t-lg">
        <p className="text-md font-semibold text-gray-900">Welcome Message</p>
        <p className="text-sm mt-1 text-gray-500">
          Configure what the assistant says first when a call is connected
        </p>
      </div>

      <div className="grid grid-cols-3 px-6 space-y-2 py-4">
        <div className="col-span-3 xl:col-span-2">
          <InputComponent
            type="textArea"
            label="Message"
            value={settings.chatWelcomeMessage}
            disabled={locked}
            style={{ height: "100px", fontSize: "13px" }}
            onChange={(e) => handleUpdateChatWelcomeMessage(e.target.value)}
          />
        </div>
        {errors.chatWelcomeMessage && <p className="text-sm text-red-500 col-span-3">{errors.chatWelcomeMessage}</p>}
      </div>

      <div className="bg-gray-50 px-6 py-3 text-right rounded-b-lg">
        {!locked && (
          <Button
            onClick={handleSave}
            disabled={isSaveDisabled}
          >
            Save
          </Button>
        )}
      </div>
    </div>
  );
}

export { ChatWelcomeMessages };
